.icon {
    width:44px;
    &.isSmall {
        width: 6px;
        margin-right: 2px;
    }
}

